import Breadcrumb from "../../components/Breadcrumb";
import FeaturesTwo from "../../components/FeaturesTwo";

const deptData = {
  mission:"To impart comprehensive knowledge in forensic medicine, medico-legal aspects and ethical medical practice. To train students in the application of forensic principles for justice, patientcare and legal responsibilities. To promote research, professional integrity, and collaboration with legal authorities in medico-legal services.", 
  vision:"To impart the knowledge of law in relation to medical practice, code of ethics and evidence based scientific approach to manage medico legal issues.",
  title:"Forensic Medicine & Toxicology",
  para:"The Department of Forensic Medicine & Toxicology plays a critical role at the intersection of medicine and law. Our department is dedicated to the application of medical knowledge to support justice, public health, and legal processes. We provide expert education, training, research, and medico-legal services in areas such as autopsy, clinical forensic medicine, toxicology, and forensic pathology."
}

const workshopImagePath = "/assets/images/departments/forensic-medicine-toxicology/modern preservation method.jpeg";

const workshopDocuments = [
  {
    title: "Report Book – Hands-on Workshop on Modern Preservation Method",
    meta: "Department of Forensic Medicine & Toxicology, TMC TU — 27 June 2026",
    path: "/assets/document/department/forensic-medicine-toxicology/Report Book - Hand-on Workshop on Modern Preservation Method FMT TMC TU 27062026.pdf",
  },
  {
    title: "Workshop Report",
    meta: "Department of Forensic Medicine & Toxicology, TMC TU — 27 June 2026",
    path: "/assets/document/department/forensic-medicine-toxicology/workshop-report.pdf",
  },
];

const ForensicMedicine = () => {
  return (
    <>
    
      

      <Breadcrumb heading={true} title={"Department of Forensic Medicine & Toxicology"} />

  
      <FeaturesTwo data={deptData}/>

      <section className="py-120">
        <div className="container">
          <div className="section-heading text-center">
            <h2 className="mb-24">Workshop on Modern Preservation Method</h2>
          </div>

          <div className="row gy-4 justify-content-center align-items-stretch">
            <div className="col-lg-6">
              <div className="row gy-4">
                {workshopDocuments.map((doc) => (
                  <div className="col-12" key={doc.path}>
                    <a
                      href={`/view-document.html?file=${encodeURIComponent(doc.path)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-100 d-flex flex-column p-24 rounded-12 border border-neutral-30 bg-white text-decoration-none"
                    >
                      <span className="w-48 h-48 rounded-circle bg-main-25 text-main-600 flex-center mb-16">
                        <i className="ph ph-file-text" style={{ fontSize: "24px" }} />
                      </span>
                      <h5 className="mb-8 text-neutral-700">{doc.title}</h5>
                      <p className="mb-16 text-neutral-500">{doc.meta}</p>
                      <span className="flex-align gap-8 text-main-600 fw-semibold mt-auto">
                        View Document
                        <i className="ph ph-arrow-right" />
                      </span>
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-6">
              <div className="h-100 p-8 rounded-12 border border-neutral-30 bg-white">
                <img
                  src={workshopImagePath}
                  alt="Hands-on Workshop on Modern Preservation Method"
                  className="w-100 h-100 rounded-8"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      
    </>
  );
};

export default ForensicMedicine;
